import PropTypes from "prop-types";
import { memo, useEffect, useState } from "react";
import { post } from "../../core/client";
import { TradeSummaryResponse } from "../../models/report";
import WidgetTile from '../../components/widget-title';
import Grid from "@mui/material/Grid";
import DatePicker from "../../components/inputs/date-picker";
import { ClearButton, SearchButton } from "../../components/buttons";
import { ArrowRight } from "@mui/icons-material";
import Alert from "@mui/material/Alert";

interface InputErrorModel {
  name: string;
  errorText: string;
}
interface TradeSummaryState {
  beginDate: string;
  endDate: string;
}

const TradeSummary = () => {

  const initialState = {
    beginDate: '',
    endDate: ''
  };
  const [state, setState] = useState<TradeSummaryState>(initialState);
  const [loading, setLoading] = useState(false);
  const [inputErrors, setInputErrors] = useState<Array<InputErrorModel>>([]);

  const initialTradeSummary: TradeSummaryResponse = {
    totalCancelledTrades: 0,
    totalCompletedTrades: 0,
    mostSoldProduct: "Veri Yok",
    mostSoldProductCount: 0,
    totalTradeAmount: 0,
    totalTradeDiscountAmount: 0,
  };
  const [tradeSummary, setTradeSummary] = useState<TradeSummaryResponse>(initialTradeSummary);

  useEffect(() => {
    loadSummaryData();
  }, []);

  const loadSummaryData = async (request?: TradeSummaryState) => {

    const requestModel = request ? request : state;

    if (!validate(requestModel)) return;

    setLoading(true);
    var response = await post<TradeSummaryResponse>("api/dealer/trade-summary", requestModel);
    if (response) {

      setTradeSummary(response);
      setLoading(false);
    }

  };

  const handleChange = (e: any) => {
    setState((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleClear = async () => {
    setState(initialState);

    loadSummaryData(initialState);
  }

  const validate = (model: TradeSummaryState) => {

    setInputErrors([]);
    let isValid = true;

    if (model.beginDate && (model.endDate === null || model.endDate === '')) {
      const error: InputErrorModel = {
        name: 'endDate',
        errorText: 'Bu alan boş bırakılamaz'
      };
      setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
      isValid = false;
    }
    else if (model.endDate && (model.beginDate === null || model.beginDate === '')) {
      const error: InputErrorModel = {
        name: 'beginDate',
        errorText: 'Bu alan boş bırakılamaz'
      };
      setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
      isValid = false;
    }
    else if (model.beginDate && model.endDate) {
      const beginDate = Date.parse(model.beginDate);
      const endDate = Date.parse(model.endDate);

      if (beginDate > endDate) {
        const error: InputErrorModel = {
          name: 'beginDate',
          errorText: 'Başlangıç tarihi bitiş tarihinden büyük olamaz'
        };
        setInputErrors((prev: Array<InputErrorModel>) => [...prev, error]);
        isValid = false;
      }
    }

    return isValid;
  }

  return (
    <div className="widget-area trade-summary">
      <WidgetTile
        title="Satış Özeti"
        showLoading={loading} />
      <div className="search">
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <DatePicker
              id="beginDate"
              caption="Başlangıç Tarihi"
              name="beginDate"
              value={state.beginDate}
              onChange={handleChange}
              errorText={inputErrors.filter(x => x.name === 'beginDate')[0]?.errorText}
            />
          </Grid>
          <Grid item sm={4}>
            <DatePicker
              caption="Bitiş Tarihi"
              id="endDate"
              name="endDate"
              value={state.endDate}
              onChange={handleChange}
              errorText={inputErrors.filter(x => x.name === 'endDate')[0]?.errorText}
            />
          </Grid>
          <Grid item sm={4}>
            <SearchButton
              className="mr-1"
              disabled={loading}
              loading={loading}
              onClick={async () => await loadSummaryData()}
            />
            <ClearButton
              disabled={loading}
              onClick={handleClear}
            />
          </Grid>
        </Grid>
      </div>


      <div className="summary-item">
        <div className="label">En Çok Satılan Ürün</div>
        <div className="icon">
          <ArrowRight />
        </div>
        <div className="value">
          {tradeSummary.mostSoldProduct}
          <strong>({tradeSummary.mostSoldProductCount} Adet)</strong>
        </div>
      </div>
      <div className="summary-item">
        <div className="label">İptal Edilmiş Satış Sayısı</div>
        <div className="icon">
          <ArrowRight />
        </div>
        <div className="value">{tradeSummary.totalCancelledTrades}</div>
      </div>
      <div className="summary-item">
        <div className="label">Toplam Satış Sayısı</div>
        <div className="icon">
          <ArrowRight />
        </div>
        <div className="value">{tradeSummary.totalCompletedTrades}</div>
      </div>
      <div className="summary-item">
        <div className="label">Toplam Satış Tutarı</div>
        <div className="icon">
          <ArrowRight />
        </div>
        <div className="value">{tradeSummary.totalTradeAmount} ₺ </div>
      </div>
      <div className="summary-item">
        <div className="label">Toplam İndirim Tutarı</div>
        <div className="icon">
          <ArrowRight />
        </div>
        <div className="value">{tradeSummary.totalTradeDiscountAmount} ₺ </div>
      </div>
      <Alert severity="info">Tarih aralığı seçilmediğinde şimdiye kadarki tüm satışların özeti gösterilmektedir.</Alert>
    </div>
  );
};

TradeSummary.propTypes = {
  load: PropTypes.bool,
};

export default memo(TradeSummary);
